/* Ряд квадратиков выбора цвета: этап воронки, цвет бизнеса.
   Первый квадратик — «без цвета»: снимает выбор и возвращает значение по умолчанию. */

import { STAGE_PALETTE } from "@mera/shared";

import { Ion } from "./icons.jsx";

export default function Palette({ value, onPick, className = "hairline-b" }) {
  return (
    <div className={`flex flex-wrap gap-2 px-4 py-3 ${className}`}>
      <button
        type="button"
        className="w-7 h-7 rounded-md flex items-center justify-center active:opacity-60"
        style={{ border: "1px dashed var(--tg-hint)", color: "var(--tg-hint)" }}
        onClick={() => onPick(null)}
        aria-label="Без цвета"
      >
        {!value ? <Ion.checkmark size={14} /> : null}
      </button>
      {STAGE_PALETTE.map((c) => (
        <button
          key={c}
          type="button"
          className="w-7 h-7 rounded-md flex items-center justify-center active:opacity-60"
          style={{
            background: c,
            boxShadow: value === c ? `0 0 0 2px var(--tg-bg), 0 0 0 4px ${c}` : "none",
          }}
          onClick={() => onPick(c)}
          aria-label={`Цвет ${c}`}
        >
          {value === c ? <Ion.checkmark size={14} style={{ color: "#fff" }} /> : null}
        </button>
      ))}
    </div>
  );
}
